import { render } from "./ConsultaPublica.vue?vue&type=template&id=32f52d20&scoped=true"
import script from "./ConsultaPublica.vue?vue&type=script&lang=js"
export * from "./ConsultaPublica.vue?vue&type=script&lang=js"

import "./ConsultaPublica.vue?vue&type=style&index=0&id=32f52d20&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f52d20"]])

export default __exports__